import Vue from 'vue'
import IACheckList from './CheckList'
import IACheckSingle from './CheckSingle'
import IADatePicker from './DatePicker'
import IAInputValue from './InputValue'
import IAShowTip from './ShowTip'
import { formatDate } from '@/helpers'
import { getPreDefinedInputMetaAttrs, INPUT_TYPES } from '@/pages/Survey/utils'

// global Vux
Vue.component('IACheckList', IACheckList)
Vue.component('IADatePicker', IADatePicker)
Vue.component('IAInputValue', IAInputValue)
Vue.component('IACheckSingle', IACheckSingle)
Vue.component('IAShowTip', IAShowTip)

/**
 * @type {{functional: boolean, render(*, {props: *}): *}}
 */
const contentInputResolver = {
  functional: true,

  render (h, { props }) {
    const { meta, cbs, idx } = props

    console.debug('[contentInputResolver] ', meta)

    let resolvedNode = null
    const inputType = meta.inputType

    // meta.required = true
    //
    // if (meta.hasOwnProperty('showType')) { // IS_BASIC
    //   inputType = meta.showType // 只有在基础类型有这个 ...
    // } else {
    //   // FIX SubType
    //   // subType	number
    //   // 非必须
    //   // 题目类型：2单项选择题 3多选 4填空题 5提示条-(跟基础类型5冲突了)
    //   // TODO: backend fix it !!!
    //   inputType = parseInt(meta.subType) - 1
    //
    //   if (inputType === 4) { // @fix 提示条
    //     inputType = INPUT_TYPES.SHOW_TIP
    //     meta.required = false
    //   }
    // }

    const preDefinedInputAttrs = getPreDefinedInputMetaAttrs(meta.title && meta.title.trim())

    switch (inputType) {
      case INPUT_TYPES.SHOW_TIP:
        resolvedNode = h('IAShowTip', {
          props: {
            value: meta.titleHtml,
            cbs,
            idx
          }
        })
        break
      case INPUT_TYPES.SINGLE_INPUT:
        resolvedNode = h('IAInputValue', {
          props: {
            value: meta.value || '',
            cbs
          },
          attrs: {
            title: '请输入',
            placeholder: '',
            type: 'text',
            ...preDefinedInputAttrs
          }
        })
        break
      case INPUT_TYPES.SINGLE_OPTION:
        resolvedNode = h('IACheckSingle', {
          props: {
            title: '',
            options: meta.question,
            cbs
          }
        })
        break
      case INPUT_TYPES.MULTI_OPTIONS:
        resolvedNode = h('IACheckList', {
          props: {
            title: '',
            isMultiple: true,
            options: meta.question,
            cbs
          }
        })
        break
      case INPUT_TYPES.SINGLE_DATE_PICKER:
        resolvedNode = h('IADatePicker', {
          props: {
            title: '请选择',
            value: meta.value || formatDate(Date.now()),
            cbs
          },
          attrs: {
            ...preDefinedInputAttrs
          }
        })
        break
      default:
        resolvedNode = h('IAInputValue', {
          props: {
            value: meta.value || '',
            cbs
          },
          attrs: {
            title: '',
            placeholder: '请填写'
          }
        })
    }

    return h('div', {
      class: ['input-adapter-resolver-wrap']
    }, [
      resolvedNode
    ])
  }
}

export {
  contentInputResolver
}
